<template>
    <div class="row">
        <div class="col-12 text-center">
            <h2 class="mb-3 h1 text-uppercase">Seleccionar abonos</h2>
        </div>
        <div class="col-12">
            <template v-if="abonos">
                <div class="row justify-content-center">
                    <div class="col-12 col-xl-10">
                        <ul class="grid">
                            <template v-for="(abono, index) in abonos">
                                <li :key="index" v-bind:class="{ 'soldout' : getAbonosMax(abono) <= 0}">
                                    <div class="thumb-container" :style="'background-image: url(&quot;' + abono.image + '&quot;);'"></div>
                                    <div class="content">
	                                    <div>
	                                        <div class="title">
	                                            {{ abono.descripcion }}                                            
	                                        </div>
	                                        <div class="price">
	                                            <p v-html="abono.nota"></p>
	                                            
	                                        </div>
	                                    </div>

                                        <footer>
                                            <div class="mt-3" v-if="abono.status == 3">
                                                <button disabled="" class="button red-content white soldout-button w-100">{{ $t('partidos.aplazado') }}</button>
                                            </div>
                                            <div class="mt-3" v-else-if="abono.venta_online_cerrada">
                                                <button disabled="" class="button red-content white soldout-button w-100">{{ $t('partidos.proximamente') }}</button>
                                            </div>
                                            <template v-else>
                                                <template v-if="getAbonosMax(abono) > 0">
                                                    <div class="form-group m-0" v-if="!abono.place_id">
                                                        <select class="form-control" v-model="abono.unidades">
                                                            <option value="0">0</option>
                                                            <template v-for="i in getAbonosMax(abono)">
                                                                <option :key="i" :value="i">{{ i }}</option>                                     
                                                            </template>                                            
                                                        </select>
                                                    </div>
                                                    <div class="row">
	                                                    <div class="col-auto flex-fill my-2 my-lg-3">
                                                        	<button class="button effect-button w-100" @click="showModal('descripcion-' + abono.id)"><span>Información</span></button>
	                                                    </div>
	                                                    <div class="col-auto flex-fill my-2 my-lg-3">
		                                                    <button @click="terminar(abono)" class="button blue-content effect-button w-100"><span>CONTINUAR</span></button>
	                                                    </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="row">
	                                                    <div class="col-auto flex-fill my-2 my-lg-3">
                                                        	<button class="button effect-button w-100" @click="showModal('descripcion-' + abono.id)"><span>Información</span></button>
	                                                    </div>
	                                                    <div class="col-auto flex-fill my-2 my-lg-3">
                                                       	 <button class="button w-100 red-content" disabled>Abonos agotados</button>
	                                                    </div>
                                                    </div>
                                                </template>
                                                
                                            </template>
                                            <InformacionModal :evento_id="abono.id" :descripcion="abono.resumen_completo" @close="closeModal"></InformacionModal>
                                        </footer>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div> 
                </div>
            </template>
            <div v-else class="loader-container" style="padding: 200px">
                <LoaderComponent></LoaderComponent>
            </div>                     
        </div>
    </div>
</template>

<script>
    import InformacionModal from '@/views/frontend/events/layouts/index/modals/InformacionModal';

    export default {
        props: ['abonos'],
        data() {
            return {
                
            }
        },
        methods: {
            getAbonosMax(abono) {
                if(abono.stock < 8) {
                    return abono.stock;
                } else {
                    return 8
                }
            },
            terminar(abono) {
                if(abono.place_id) {
                    this.$emit('finalizarAbonoRecinto', abono);
                } else {
                    if(abono.unidades > 0) {
                        var datos_compradores = [];
                        for (var j = 0; j < abono.unidades; j++) {
                            datos_compradores.push({
                                tipo_abono: abono
                            });
                        }

                        this.$emit('finalizarAbonoSinRecinto', abono, datos_compradores);

                    } else {
                        this.$toast.error('Debes seleccionar al menos un abono.');
                    }
                }
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            }
        },
        components: {
            InformacionModal
        }
    }
</script>
